import { Navigate, useParams, useSearchParams } from "react-router";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { NotFoundInAppPage } from "@/components/pages_public/404/NotFound";
import { useRoleplayQuery, useScenarioQuery } from "@/graphql";

import { ScenarioContent } from "./ScenarioContent";

function ScenarioPageContainer() {
  const { scenarioSlug = "", roleplaySlug = "" } = useParams();
  const [searchParams] = useSearchParams();
  const isBareLayout = searchParams.get("layout") === "bare";

  const { data, loading } = useScenarioQuery({
    // 'network-only' to avoid cache issues when update permissions
    fetchPolicy: "network-only",
    variables: {
      scenarioSlug,
    },
    skip: !scenarioSlug,
  });

  const scenario = data?.scenario;

  const { data: roleplayData } = useRoleplayQuery({
    variables: {
      slug: roleplaySlug,
    },
    skip: !roleplaySlug,
  });

  const roleplay = roleplayData?.roleplay;
  const showIntro = !!(data && !data.featureIntroduced);
  const isScenarioBelongToRoleplay =
    roleplay?.scenarios?.some((s) => s?.slug === scenarioSlug) || false;
  const isValidUrl = !roleplaySlug || (roleplay && isScenarioBelongToRoleplay);

  if (!loading && !scenario) {
    return <NotFoundInAppPage />;
  }

  if (!loading && !isValidUrl) {
    return <Navigate to={`/scenarios/${scenarioSlug}`} />;
  }

  return (
    <>
      <SEOHead title={`${scenario?.name || ""} - Scenario Details - Exec`} />
      {!isBareLayout && <Nav pageLoading={loading} />}
      <ScenarioContent
        scenario={scenario ?? undefined}
        showIntro={showIntro}
        loading={loading}
        roleplay={roleplay ?? undefined}
        isBareLayout={isBareLayout}
      />
    </>
  );
}

export function ScenarioPage() {
  const [searchParams] = useSearchParams();
  const isBareLayout = searchParams.get("layout") === "bare";

  return (
    <Authenticate
      maxWidth="100%"
      layout={isBareLayout ? "compact" : "full"}
      navHeight={isBareLayout ? 0 : undefined}
    >
      <ScenarioPageContainer />
    </Authenticate>
  );
}
